import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import classnames from "classnames";

import * as actions from "../../../store/actions";
import { VALIDATE_TEMPLATE } from "../../../store/actions/actionTypes";

import AppointmentIcon from "../../../components/uiElements/icons/profileIcons/AppointmentIcons";
import Button from "../../../components/formElements/button/Button";
import CustomTextArea from "../../../components/formElements/customTextArea/CustomTextArea";
import ConfirmDelete from "../../../components/uiElements/modal/ConfirmDelete";

const ViewEditTemplate = ({
  history,
  form,
  templates,
  setTemplateData,
  clearTemplateData,
  getTemplateById,
  editTemplateById,
  validateData,
  match,
  editMode,
  setEditMode,
  clearEditMode,
  deleteTemplateById,
}) => {
  const id = match?.params?.id;

  const [modal, setShowModal] = useState(false);
  const [templateId, setTemplateId] = useState(0);

  useEffect(() => {
    if (form && form.templatesValid) {
      editTemplateById(id, () => {
        history.goBack();
      });
    }

    form.templatesValid = false;
    // eslint-disable-next-line
  }, [form]);

  useEffect(() => {
    getTemplateById(id);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    return () => {
      clearEditMode();
    };
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {modal && (
        <ConfirmDelete
          isOpen={modal}
          onSuccess={() => {
            deleteTemplateById(templateId, () => history.goBack());
          }}
          closeModal={() => setShowModal(!modal)}
        />
      )}
      <div className="row">
        <div className="col-md-6 d-flex align-items-center text-dark">
          <p className="h3">
            <AppointmentIcon
              type="leftArrow"
              className="back-button"
              onClick={() => {
                history.goBack();
                clearTemplateData();
              }}
            />
            <span className="ml-1 h4 text-dark">
              {editMode ? "Edit " : ""} Note
            </span>
          </p>
        </div>

        <div className="col-md-4 ml-auto editnotebtn">
          {editMode ? (
            ""
          ) : (
            <div className="d-flex justify-content-between align-items-center mt-2 px-2">
              <Button
                onClick={() => {
                  setEditMode();
                }}
                label="Edit"
                className="mr-3 font-weight-normal"
              />
              <Button
                type="outline"
                label={"Delete"}
                onClick={() => {
                  setShowModal(true);
                  setTemplateId(templates?.id);
                }}
                className="btn-block font-weight-normal"
              />
            </div>
          )}
        </div>
      </div>
      <div
        className={classnames(
          "note-template-container",
          editMode ? "" : "disable"
        )}
      >
        <>
          <div style={{ width: "100%" }}>
            <CustomTextArea
              label="Note Name"
              value={templates?.note_name || ""}
              className="mycontentdivMain"
              error={form.note_name}
              onChange={val => setTemplateData({ note_name: val })}
            />
          </div>
          <div style={{ width: "100%" }}>
            <CustomTextArea
              label="Chief Complaint"
              value={templates?.chief_complaint || ""}
              className="mycontentdivMain"
              error={form.chief_complaint}
              onChange={val => setTemplateData({ chief_complaint: val })}
            />
          </div>
        </>
        <div style={{ width: "100%" }}>
          <CustomTextArea
            label="Notes"
            value={templates?.notes}
            className="mycontentdivMain "
            onChange={val => setTemplateData({ notes: val })}
            error={form.notes}
          />
        </div>

        <div style={{ width: "100%" }}>
          <CustomTextArea
            label="Assessment"
            value={templates?.assessment || ""}
            className="mycontentdivMain"
            error={form.assessment}
            onChange={val => setTemplateData({ assessment: val })}
          />
        </div>
        <div style={{ width: "100%" }}>
          <CustomTextArea
            label="Plan"
            value={templates?.plan || ""}
            className="mycontentdivMain"
            error={form.plan}
            onChange={val => setTemplateData({ plan: val })}
          />
        </div>
        {editMode ? (
          <div className="col-md-4 d-flex justify-content-between align-items-center mt-2 px-2">
            <Button
              onClick={() => {
                validateData(templates);
              }}
              label="Update"
              className="mr-3"
            />
            <Button
              type="outline"
              label={"Cancel"}
              onClick={() => {
                history.goBack();
                clearTemplateData();
              }}
              className="btn-block"
            />
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

const mapStoreToProps = ({ dashboard, validation }) => ({
  templates: dashboard.templates.currentData,
  form: validation.data,
  editMode: dashboard.templates.editMode,
});

const mapDispatchToProps = dispatch => ({
  validateData: templates =>
    dispatch(actions.validateData(VALIDATE_TEMPLATE, templates)),
  getTemplateById: id => dispatch(actions.getTemplateById(id)),
  setTemplateData: Data => dispatch(actions.setTemplateData(Data)),
  clearTemplateData: () => dispatch(actions.clearTemplateData()),
  editTemplateById: (id, cb) => dispatch(actions.editTemplateById(id, cb)),
  setEditMode: () => dispatch(actions.setEditMode()),
  clearEditMode: () => dispatch(actions.clearEditMode()),
  deleteTemplateById: (tempID, cb) =>
    dispatch(actions.deleteTemplateById(tempID, cb)),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(ViewEditTemplate)
);
